import moment from "moment";
import React from "react";
import renderSponsors from "components/Dashboard/renderSponsors";
import renderPartners from "components/Dashboard/renderPartners";
import { CPDPoints } from "components/CPDPoints";
import { Link } from "react-router";

const GuestSearch = ({ webinars }) => (
  <div className="section_search_list">
    {webinars.length > 0 ? (
      webinars.map((webinar) =>
        webinar.webinar_type === "recorded" ? (
          <Link
            onClick={() =>
              localStorage.setItem("nonLoggedInUrl", `/webinars/${webinar.id}`)
            }
            key={webinar.id}
            to={`/webinars/${webinar.id}`}
          >
            <Webinar webinar={webinar} />
          </Link>
        ) : (
          <Webinar key={webinar.id} webinar={webinar} />
        )
      )
    ) : (
      <p style={{ textAlign: "center" }}>
        There are no items matching your query, please search for a different
        keyword.
      </p>
    )}
  </div>
);

const Webinar = ({ webinar }) => {
  const {
    id,
    webinar_title,
    partnerships,
    start_date,
    end_date,
    sponsors,
    sponsor,
  } = webinar;
  return (
    <div className="section_previous" id={`upcoming${id}`}>
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        <div className="col l3 webinar_title">
          <p className="section_previous_theme"></p>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div>
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
        {webinar && webinar.document_url ? (
          <div className="col l1">
            <div className="current_points">
              Agenda:
              <a
                className="download_attachment"
                target="_blank"
                href={webinar.document_url}
              >
                Download
              </a>
            </div>
          </div>
        ) : null}
        <div className="col l2">
          {/*  <p className="section_date">{moment(start_date).format('D/M/YYYY')}</p>*/}
          {/*  <p className="section_time">{moment(start_date).format('h:mm a').toUpperCase()}</p>*/}
        </div>
        <div className="col l2 section_topic">
          <p className="current_card_date">
            <span>{moment(start_date).format("dddd").toUpperCase()} </span>
            <span>{moment(start_date).format("D/M/YYYY").toUpperCase()} </span>
            {/*{moment(start_date).format('YYYY')}*/}
          </p>
          <p className="current_card_time">
            {moment(start_date).format("h:mm a").toUpperCase()}
            {" - "}
            {moment(end_date).format("h:mm a").toUpperCase()}
          </p>
        </div>
        <div className="col l2">
          {sponsors && sponsors.length && sponsors.length > 0 ? (
            <div>
              <p>Brought to you by:</p>
              {renderSponsors(sponsor, sponsors, false)}
            </div>
          ) : null}
        </div>
        {webinar && webinar.cpd_points ? (
          <div className="col l1">
            <div className="current_points">
              <CPDPoints webinar={webinar} />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default GuestSearch;



// WEBPACK FOOTER //
// ./src/components/GuestSearch/GuestSearch.jsx